import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/lib/utils";
import { SECTION_CONTAINER_WIDTHS } from "@/components/atoms/section-constants";
import type { SectionContentProps } from "./SectionContent.props";
const baseContainerClass = "mx-auto w-full px-4 md:px-6 lg:px-8";

/**
 * SectionContent provides responsive container layout with width constraints.
 * Handles horizontal padding and max-width for section content areas.
 */
export const SectionContent = t0 => {
  const $ = _c(7);
  const {
    as: t1,
    className,
    size: t2,
    children
  } = t0;
  const Component = t1 === undefined ? "div" : t1;
  const size = t2 === undefined ? "container" : t2;
  const t3 = SECTION_CONTAINER_WIDTHS[size];
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn("relative z-1", baseContainerClass, t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== Component || $[4] !== children || $[5] !== t4) {
    t5 = <Component className={t4}>{children}</Component>;
    $[3] = Component;
    $[4] = children;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};

/** @deprecated Use SectionContent directly */
export const SectionContainer = SectionContent;